import type { Action } from 'redux';
import { isSavedAdAccount } from '../../../../../main/components/PartnerManager/utils';
import dash_api from '../../../../../main/support/dash_api';
import type { AdAccount } from '../../../../../main/types/adPartnerTypes';
import { ReduxAsyncAction } from '../../../../services/ReduxAsyncAction';
import type { GetRedditAdAccountsPayload } from '../Reddit.types';

const GetRedditAdAccounts = new ReduxAsyncAction<'GET_REDDIT_AD_ACCOUNTS', AdAccount[], GetRedditAdAccountsPayload>(
  'GET_REDDIT_AD_ACCOUNTS'
);
GetRedditAdAccounts.registerRequest((savedAccounts: AdAccount[]) => {
  return dash_api.get('/v1/reddit/get-accounts').then(({ data }) => {
    return {
      accounts: Array.isArray(data)
        ? data.map((account) => ({ ...account, checked: isSavedAdAccount(account.account_id, savedAccounts) }))
        : [],
    };
  });
});
export const GET_REDDIT_AD_ACCOUNTS = GetRedditAdAccounts.actionNamespaceConstants;
export const getRedditAdAccounts = GetRedditAdAccounts.request;

export type GetRedditAdAccountsAction = Action<typeof GET_REDDIT_AD_ACCOUNTS.response> & {
  data: GetRedditAdAccountsPayload;
};
